import styled from '@emotion/styled';
import { COLORS3 as COLORS, FONT, SPACING } from '../../styles/emotion';
import MEDIA_QUERY_V2 from '../../styles/emotion/mediaQueryV2';

export const Section = styled.div`
  border-top: solid 1px ${COLORS.BLACK_030};
  margin: ${SPACING.LG} 0 0 0;
`;

export const Container = styled.div`
  padding: ${SPACING.LG};
  ${MEDIA_QUERY_V2.MOBILE} {
    padding: ${SPACING.S32} ${SPACING.S24};
  }
`;

export const Title = styled.h2`
  margin: 0;
  font-size: ${FONT.FONT_SIZE_LARGER};

  ${MEDIA_QUERY_V2.MOBILE} {
    font-size: ${FONT.FONT_SIZE_REGULAR};
  }
`;

export const List = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin-top: ${SPACING.LG};

  ${MEDIA_QUERY_V2.MOBILE} {
    margin-top: ${SPACING.S24};
  }
`;

export const ListItem = styled.li`
  flex: none;
  width: 33.33%;
  margin-bottom: ${SPACING.S16};
  padding-right: ${SPACING.MD};
  text-align: left;

  ${MEDIA_QUERY_V2.TABLET} {
    width: 50%;
  }

  ${MEDIA_QUERY_V2.MOBILE} {
    width: 100%;
  }

  a {
    font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  }
`;
